import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import store from './store';
import * as serviceWorker from './serviceWorker';
import i18next from './locales/i18n';
import setSemanticCss from './semanticCssHelper';
import App from './components/App';

const direction = i18next.dir();
setSemanticCss(direction);

let currentLangDirection;
store.subscribe(() => {
    let previousLangDirection = currentLangDirection;
    currentLangDirection = i18next.dir();

    if (previousLangDirection !== currentLangDirection) {
        setSemanticCss(currentLangDirection);
    }
});

document.body.setAttribute('dir', direction);

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

serviceWorker.unregister();

